var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var stardogGraphQlTokens = require('./tokens').stardogGraphQlTokens;
import { BaseGraphQlParser } from './BaseGraphQlParser';
import { getStardogGraphQlVisitor } from 'graphql/StardogGraphQlVisitor';
var StardogGraphQlParser = /** @class */ (function (_super) {
    __extends(StardogGraphQlParser, _super);
    function StardogGraphQlParser(options) {
        var _this = _super.call(this, options, stardogGraphQlTokens) || this;
        _this.visitCst = function (cst) {
            // To save resources while parsing, the visitor is a singleton.
            if (!_this.stardogGraphQlVisitor) {
                var BaseStardogGraphQlVisitor = _this.getBaseCstVisitorConstructorWithDefaults();
                _this.stardogGraphQlVisitor = getStardogGraphQlVisitor(BaseStardogGraphQlVisitor, _this);
            }
            else {
                _this.stardogGraphQlVisitor.$resetState();
            }
            return _this.stardogGraphQlVisitor.visit(cst, _this.input);
        };
        _this.parse = function (document, entryRule) {
            if (entryRule === void 0) { entryRule = _this.Document; }
            _this.input = _this.tokenize(document);
            var cst = entryRule.call(_this);
            var _a = _this.visitCst(cst), sparqlErrors = _a.sparqlErrors, stardogGraphQlErrors = _a.stardogGraphQlErrors;
            var graphQlErrors = _this.errors;
            return {
                errors: graphQlErrors.concat(stardogGraphQlErrors, sparqlErrors),
                cst: cst,
            };
        };
        _this.performSelfAnalysis();
        return _this;
    }
    return StardogGraphQlParser;
}(BaseGraphQlParser));
export { StardogGraphQlParser };
